/* global axios */
import ApiClient from '../ApiClient';

class AuditTrailsAPI extends ApiClient {
  constructor() {
    super('audit_trails', { accountScoped: true, wgpt: true });
  }

  filter(data) {
    const { filters = [], ...params } = data;

    const hasDateFilter = filters.some(
      filter => filter.attributeKey === 'date'
    );

    if (hasDateFilter) {
      params.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    return axios.post(`${this.url}/filter`, { filters }, { params });
  }
}

export default new AuditTrailsAPI();
